import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { assertNever } from 'owa-assert';
import { createOneDriveFolder } from 'owa-fileprovider-services';
import { createShareableFolderModelForOneDriveItem } from './typeConverters';
import { FolderModel, ShareableFolderModel } from '../store/schema/FolderModel';
import { FolderSelectorProviderType } from '../store/schema/FolderSelectorProviderType';
import { HTTPResponseError } from '../types/HTTPResponseError';

/**
 * Creates a folder for provider. If no `parentFolderId` is provided then the folder
 * will be created in the root folder of the file provider.
 */
export function createFolderForProvider(
    providerType: AttachmentDataProviderType.OneDrivePro,
    endpointUrl: string,
    folderName: string,
    parentFolderId?: string
): Promise<ShareableFolderModel>;
export async function createFolderForProvider(
    providerType: FolderSelectorProviderType,
    endpointUrl: string,
    folderName: string,
    parentFolderId?: string
): Promise<FolderModel> {
    switch (providerType) {
        case AttachmentDataProviderType.OneDrivePro:
            return await createFoldersForOneDrivePro(endpointUrl, folderName, parentFolderId);
        default:
            return assertNever(providerType);
    }
}

async function createFoldersForOneDrivePro(
    endpointUrl: string,
    folderName: string,
    parentFolderId?: string
): Promise<ShareableFolderModel> {
    const { errorResponse, result } = await createOneDriveFolder(
        AttachmentDataProviderType.OneDrivePro,
        endpointUrl,
        folderName,
        parentFolderId
    );

    if (errorResponse) {
        throw new HTTPResponseError('Unable to create folder', errorResponse);
    } else {
        return createShareableFolderModelForOneDriveItem(
            result,
            AttachmentDataProviderType.OneDrivePro
        );
    }
}
